import React from "react";
import AppInformePedidosReactTable from "../components/AppInformePedidosReactTable";

const InformePedidos = () => {
  return (
    <>
      <AppInformePedidosReactTable />
    </>
  );
};

export default InformePedidos;